// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.average-life[data-v-7cc211ae] {
  color: #333;
  font-family: 'AvenirNextLTW01-Regular', Arial, serif;
  font-size: 14px;
}
.average-life .table-list[data-v-7cc211ae] {
  list-style-type: none;
  margin: auto;
  padding: 0;
}
.average-life .table-list li[data-v-7cc211ae] {
  border-bottom: 1px solid #ccc;
  display: inline-block;
  line-height: 22px;
  padding-right: 10px;
  width: 100%;
  margin-bottom: 0;
}
.average-life .table-list li .data[data-v-7cc211ae] {
  float: right;
  max-width: 10%;
}
.average-life .table-list .top-border[data-v-7cc211ae] {
  border-top: 1px solid #ccc;
  height: 23px;
}
.average-life .table-list .blue-bar[data-v-7cc211ae] {
  background-color: #f2fafd;
  display: inline-block;
  height: 21px;
  padding-left: 10px;
  white-space: nowrap;
}
.average-life .sub-info[data-v-7cc211ae] {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/AverageLife.vue","webpack://./AverageLife.vue"],"names":[],"mappings":"AACC;EACC,WAAA;EACA,oDAAA;EACA,eAAA;ACAF;ADHC;EAKE,qBAAA;EACA,YAAA;EACA,UAAA;ACCH;ADRC;EASG,6BAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;ACEJ;ADhBC;EAgBI,YAAA;EACA,cAAA;ACGL;ADpBC;EAqBG,0BAAA;EACA,YAAA;ACEJ;ADxBC;EAyBG,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACEJ;AD/BC;EAiCE,gBAAA;ACCH","sourcesContent":["\n\t.average-life {\n\t\tcolor: #333;\n\t\tfont-family: 'AvenirNextLTW01-Regular', Arial, serif;\n\t\tfont-size: 14px;\n\t\t.table-list {\n\t\t\tlist-style-type: none;\n\t\t\tmargin: auto;\n\t\t\tpadding: 0;\n\t\t\tli {\n\t\t\t\tborder-bottom: 1px solid #ccc;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tline-height: 22px;\n\t\t\t\tpadding-right: 10px;\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\t.data {\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tmax-width: 10%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.top-border {\n\t\t\t\tborder-top: 1px solid #ccc;\n\t\t\t\theight: 23px;\n\t\t\t}\n\t\t\t.blue-bar {\n\t\t\t\tbackground-color: #f2fafd;\n\t\t\t\tdisplay:inline-block;\n\t\t\t\theight: 21px;\n\t\t\t\tpadding-left: 10px;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t}\n\t\t.sub-info {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n",".average-life {\n  color: #333;\n  font-family: 'AvenirNextLTW01-Regular', Arial, serif;\n  font-size: 14px;\n}\n.average-life .table-list {\n  list-style-type: none;\n  margin: auto;\n  padding: 0;\n}\n.average-life .table-list li {\n  border-bottom: 1px solid #ccc;\n  display: inline-block;\n  line-height: 22px;\n  padding-right: 10px;\n  width: 100%;\n  margin-bottom: 0;\n}\n.average-life .table-list li .data {\n  float: right;\n  max-width: 10%;\n}\n.average-life .table-list .top-border {\n  border-top: 1px solid #ccc;\n  height: 23px;\n}\n.average-life .table-list .blue-bar {\n  background-color: #f2fafd;\n  display: inline-block;\n  height: 21px;\n  padding-left: 10px;\n  white-space: nowrap;\n}\n.average-life .sub-info {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
